;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { ComponentPropsWithoutRef } from 'react'

import { QogitaLogoEmblem } from '../QogitaLogo'

type PageErrorLogoProps = ComponentPropsWithoutRef<'svg'>

export function PageErrorLogo(props: PageErrorLogoProps) {
  return (
    <QogitaLogoEmblem
      {...props}
      theme="whiteOnPrimary"
      width={44}
      height={44}
    />
  )
}
